
export const changeName = (name) => ({
    type: 'CHANGE_NAME',
    name
});

export const changeProfileImage = (profileImage)=>({
    type: 'CHANGE_PROFILEIMAGE',
    profileImage
});